module.exports = __webpack_public_path__ + "static/media/assct_logo.6fcd3243.png";